<template>
    <div class="ref020-public-header">
        <div class="ref020-public-header-row">
            <!-- 좌측: 브랜드 + 인트로 nav -->
            <div class="ref020-public-header-left">
                <a class="ref020-public-brand" href="/" title="GONELO B2B Global Logistics Partner">
                    <i>✈</i>
                    <span class="ref020-public-brand-name">GONELO</span>
                    <span class="ref020-public-brand-tagline">B2B Global Logistics Partner</span>
                </a>

                <nav v-if="introItems && introItems.length > 0" class="ref020-public-intro-nav">
                    <a v-for="(item, index) in introItems"
                       :key="'intro-' + index"
                       :href="item.url"
                       :target="item.target"
                       :title="item.name"
                       class="ref020-public-intro-item">
                        <i v-if="item.icon" class="material-icons">{{ item.icon }}</i>
                        <span>{{ item.name }}</span>
                    </a>
                </nav>
            </div>

            <!-- 우측: 가입 / 로그인 -->
            <div class="ref020-public-header-right">
                <a :href="registerUrl"
                   :title="registerLabel"
                   class="ref020-public-btn ref020-public-btn-default">
                    {{ registerLabel }}
                </a>
                <a :href="loginUrl"
                   :title="loginLabel"
                   class="ref020-public-btn ref020-public-btn-primary">
                    {{ loginLabel }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
// REF-020 hot-fix #20 안건 66 (2026-05-12) — public 헤더 (비로그인 전용).
//
// 기존 header.vue 가 logined / !logined 두 케이스를 모두 처리하면서 v-if 분기 + 빈 영역 디자인 부담.
// 비로그인 전용 컴포넌트로 분리 → 레이아웃 단순화, 각 컴포넌트 자체 가정 명확.
//
// 표시 영역:
//   - 좌측: 브랜드 (GONELO 로고) + 인트로 nav (What's GONELO? / 서비스안내 / 제휴문의)
//   - 우측: 가입 / 로그인 버튼
//
// 인트로 nav 데이터는 MenuResolve::writeHeaderIntroMenu() 산출 → _header.blade.php 가 props 로 전달.
//
// 로그인 사용자는 본 컴포넌트 사용 안 함 (별도 app-header).
export default {
    name: 'app-header-public',
    props: {
        // 인트로 nav 항목 — Array of { name, url, icon, target }
        introItems: {
            type: Array,
            default: () => [],
        },
        // 가입 / 로그인 URL · 라벨 (blade 의 trans 결과 주입)
        loginUrl: {
            type: String,
            default: '/users/login',
        },
        loginLabel: {
            type: String,
            default: '로그인',
        },
        registerUrl: {
            type: String,
            default: '/users/register',
        },
        registerLabel: {
            type: String,
            default: '회원가입',
        },
    },
};
</script>

<style scoped>
/* 컨테이너 — 흰 배경 + 미세 보더 (app-header 와 시각 톤 일관) */
.ref020-public-header {
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ref020-public-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem 1.25rem;
    gap: 1.25rem;
    font-size: 1rem;
}

/* 좌측 그룹 — 브랜드 + 인트로 nav */
.ref020-public-header-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex-shrink: 0;
}

/* 브랜드 — 비행기 + GONELO + tagline (app-header 의 brand 동일 톤) */
.ref020-public-brand {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: #000;
    letter-spacing: -0.02em;
}
.ref020-public-brand i {
    font-style: normal;
    font-size: 1.25rem;
    color: #000;
}
.ref020-public-brand-name {
    font-weight: 700;
    font-size: 1.0625rem;
    color: #000;
}
.ref020-public-brand-tagline {
    font-size: 1rem;
    color: #6b7280;
}

/* 인트로 nav — 단순 링크 (app-header 의 header-links 와 동일 톤) */
.ref020-public-intro-nav {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
}
.ref020-public-intro-item {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.4375rem 0.75rem;
    color: #525866;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 0.375rem;
    white-space: nowrap;
    transition: all 0.15s ease;
}
.ref020-public-intro-item i.material-icons {
    font-size: 1.1666rem;
    color: #525866;
}
.ref020-public-intro-item:hover {
    background: #f6f8fa;
    color: #000;
}
.ref020-public-intro-item:hover i.material-icons {
    color: #000;
}

/* 우측 그룹 — 가입 / 로그인 */
.ref020-public-header-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
}

/* 버튼 (가입 / 로그인) */
.ref020-public-btn {
    display: inline-flex;
    align-items: center;
    padding: 0.4375rem 1rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 0.375rem;
    text-decoration: none;
    white-space: nowrap;
    transition: all 0.15s ease;
}
.ref020-public-btn-default {
    color: #1f2937;
    background: #fff;
    border: 1px solid #d1d5db;
}
.ref020-public-btn-default:hover {
    background: #f6f8fa;
    border-color: #9ca3af;
}
.ref020-public-btn-primary {
    color: #fff;
    background: #000;
    border: 1px solid #000;
}
.ref020-public-btn-primary:hover {
    background: #1f2937;
    border-color: #1f2937;
}
</style>
